import PropTypes from "prop-types";
import { useMemo } from "react";
import { CssBaseline } from "@mui/material";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import palette from "./palette";
import shadows from "./shadows";
import typography from "./typography";
import GlobalStyles from "./globalStyles";
import customShadows from "./customShadows";
import componentsOverride from "./overrides";

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }: any) {
  const isDark = useSelector(
    (state: RootState) => state.appUser.darkTheme ?? false,
  );

  // createTheme() and componentsOverride() must live inside the memo too:
  // calling them on every render produced a brand new theme object, which
  // re-rendered every themed MUI component in the tree.
  const theme = useMemo(() => {
    const themeOptions: any = {
      palette: {
        ...palette(isDark ? "dark" : "light"),
        mode: isDark ? "dark" : "light",
      },
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(),
      customShadows: customShadows(),
    };
    const nextTheme = createTheme(themeOptions);
    nextTheme.components = componentsOverride(nextTheme);
    return nextTheme;
  }, [isDark]);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
